import { render } from "./DownloadIcon2.vue?vue&type=template&id=6c4d112f&ts=true"
import script from "./DownloadIcon2.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadIcon2.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DownloadIcon2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c4d112f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c4d112f', __exports__)) {
    api.reload('6c4d112f', __exports__)
  }
  
  module.hot.accept("./DownloadIcon2.vue?vue&type=template&id=6c4d112f&ts=true", () => {
    api.rerender('6c4d112f', render)
  })

}


export default __exports__